// extracted by mini-css-extract-plugin
export default {"label":"Label-module__label__9Leti"};